import "./module/userAgentChecker.min.js"
import "./module/responsive.js"

import Swiper from "swiper";

var myswiper = new Swiper('.swiper-container', {
    spaceBetween: 50,
    slidesPerView: 'auto',
    centeredSlides: true,
    speed: 3000,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      667: {
        spaceBetween: 20
      }
    }
});